import React from 'react';
import { motion } from 'framer-motion';
import { pillarTotals } from '../data/plan';
import { pillarStyles } from '../utils/stats';
export function PillarSplit() {
  return <div data-id="element-71" data-mp="xrfwit74u33q">
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-ink-800" role="img" aria-label="Pillar split across the eight weeks" data-id="element-72" data-mp="xr6fvw7z98ap">
        {pillarTotals.map(p => <motion.span key={p.pillar} initial={{
        width: 0
      }} animate={{
        width: `${p.share}%`
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} style={{
        backgroundColor: pillarStyles[p.pillar].hex
      }} className="block h-full" data-id="element-73" data-mp="sqih2odibn5x" />)}
      </div>

      <ul className="mt-5 space-y-3" data-id="element-74" data-mp="1bjmac8mtby00">
        {pillarTotals.map(p => <li key={p.pillar} className="flex items-baseline justify-between gap-3" data-id="element-75" data-mp="52hd7sr9wuwu">
            <span className="flex items-center gap-2" data-id="element-76" data-mp="50efemjvpxhk">
              <span className={`h-2 w-2 rounded-full ${pillarStyles[p.pillar].dot}`} aria-hidden="true" data-id="element-77" data-mp="2we9ic3smk4" />
              <span className="text-sm text-chalk" data-id="element-78" data-mp="19ex5zchkuuk2">{p.pillar}</span>
              <span className="font-mono text-[11px] text-faint" data-id="element-79" data-mp="1dgacloshv1s1">{p.slots} slots</span>
            </span>
            <span className="flex items-baseline gap-2" data-id="element-80" data-mp="zh0uukon3zly">
              <span className="font-display text-xl text-chalk" data-id="element-81" data-mp="zilom834reir">{p.share}%</span>
              <span className="font-mono text-[10px] text-faint" data-id="element-82" data-mp="14dhmhov1sw3s">target {p.target}</span>
            </span>
          </li>)}
      </ul>
    </div>;
}